export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./SimpleTable.vue?vue&type=template&id=bbb995d6"


//////////////////
// WEBPACK FOOTER
// ./src/components/Tables/SimpleTable.vue?vue&type=template&id=bbb995d6
// module id = 1431
// module chunks = 31